import { useEffect } from 'react';
import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { translate } from '../../Services/translation';
import {
  CookieConsentBlockItem,
  CookieConsentGroup,
  CookieConsentTableHeader,
} from './Types';
interface CookieConsentProps {
  modalTitle: string;
  modalDescription: string;
  settingsTitle: string;
  tableHeaders?: CookieConsentTableHeader[];
  blockItems?: CookieConsentBlockItem[];
  groups?: CookieConsentGroup[];
  revision?: number;
}

const CookieConsent = ({
  modalTitle,
  modalDescription,
  settingsTitle,
  tableHeaders = [],
  blockItems = [],
  groups = [],
  revision = 0,
}: CookieConsentProps) => {
  const getCookieTableItem = (blockItem) => {
    const item = { is_regex: blockItem.isRegex };
    for (let index in tableHeaders) {
      const header = tableHeaders[index];
      if (!header) continue;

      if (!blockItem.columns[index]) {
        item[header.key] = '';
      } else {
        item[header.key] = blockItem.columns[index];
      }
    }
    return item;
  };

  useEffect(() => {
    if (groups.length == 0) {
      return;
    }

    // obtain plugin
    const cc = initCookieConsent();

    // run plugin with config
    cc.run({
      current_lang: 'en',
      autoclear_cookies: true, // default: false
      page_scripts: true, // default: false
      revision: revision, // default: 0

      languages: {
        en: {
          consent_modal: {
            title: modalTitle,
            description: modalDescription,
            primary_btn: {
              text: translate('cc.accept-all'),
              role: 'accept_all',
            },
            secondary_btn: {
              text: translate('cc.reject-all'),
              role: 'accept_necessary',
            },
          },
          settings_modal: {
            title: settingsTitle,
            save_settings_btn: translate('cc.settings.save'),
            accept_all_btn: translate('cc.accept-all'),
            reject_all_btn: translate('cc.reject-all'),
            close_btn_label: translate('cc.close-all'),
            cookie_table_headers: tableHeaders.map((header) => ({
              [header.key]: header.label,
            })),
            blocks: groups.map((group) => ({
              title: group.title,
              description: group.description,
              toggle: group.toggle ? group.toggle : undefined,
              cookie_table:
                group.key && blockItems[group.key]
                  ? blockItems[group.key].map((item) =>
                      getCookieTableItem(item)
                    )
                  : undefined,
            })),
          },
        },
      },
    });
  }, []);

  return null;
};

export default CookieConsent;
